import React, { useState } from 'react';
import Modal from 'react-modal';
import { addLegacyFinancialAliases } from '../utils/obracunFields';
import '../css/PersonForm.css';

function PersonForm({ onAddPerson, firms }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [glovoId, setGlovoId] = useState('');
  const [woltId, setWoltId] = useState('');
  const [vozilo, setVozilo] = useState('');
  const [vlasnik, setVlasnik] = useState('');
  const [registracija, setRegistracija] = useState('');
  const [firmId, setFirmId] = useState('default');
  const [iban, setIban] = useState('');
  const [fee, setFee] = useState(0);
  const [tax, setTax] = useState(0);
  const [rent, setRent] = useState(0);
  const [petrol, setPetrol] = useState(0);
  const [acom, setAcom] = useState(0);
  const [utility, setUtility] = useState(0);
  const [sim, setSim] = useState(0);
  const [advance, setAdvance] = useState(0);
  const [bonus, setBonus] = useState(0);
  const [ostalo, setOstalo] = useState(0);

  const [startMonth, setStartMonth] = useState(new Date().getMonth() + 1);
  const [startYear, setStartYear] = useState(new Date().getFullYear());

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setName('');
    setEmail('');
    setGlovoId('');
    setWoltId('');
    setVozilo('');
    setVlasnik('');
    setRegistracija('');
    setFirmId('default');
    setIban('');
    setFee(0);
    setTax(0);
    setRent(0);
    setPetrol(0);
    setAcom(0);
    setUtility(0);
    setSim(0);
    setAdvance(0);
    setBonus(0);
    setOstalo(0);
    setModalIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailNorm = (email || '').trim().toLowerCase();
    const normalizedGlovoId = (glovoId || '').trim().toLowerCase();
    const normalizedWoltId = (woltId || '').trim().toLowerCase();
    const person = addLegacyFinancialAliases({
      name,
      email: emailNorm,
      emailLower: emailNorm,
      city: '',
      comment: '',
      fee,
      appKnjig: acom,
      doprinosi: sim,
      renta: rent,
      rentSmjestaj: 0,
      oprema: 0,
      akontacija: advance,
      gorivo: petrol,
      ostalo,
      bonus,
      tekuciRacun: '',
      zasticeniRacun: '',
      iban,
      riderID: normalizedGlovoId,
      glovoId: normalizedGlovoId,
      woltId: normalizedWoltId,
      vozilo: vozilo.trim(),
      vlasnik: vlasnik.trim(),
      registracija: registracija.trim(),
      firmId,
      startMonth,
      startYear,
      archived: false,
      tax,
      rent,
      petrol,
      acom,
      utility,
      sim,
      advance,
    });

    onAddPerson(person);
    closeModal();
  };

  return (
    <div>
      <button className="add-person-button" onClick={openModal}>
        Dodaj osobu
      </button>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Dodaj osobu</h2>
        <form onSubmit={handleSubmit} className="person-form">
          <div className="form-group">
            <label>Ime:</label>
            <input
              type="text"
              placeholder="Ime"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>IBAN:</label>
            <input
              type="text"
              placeholder="IBAN"
              value={iban}
              onChange={(e) => setIban(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Glovo ID:</label>
            <input
              type="text"
              placeholder="Glovo ID"
              value={glovoId}
              onChange={(e) => setGlovoId(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Wolt ID:</label>
            <input
              type="text"
              placeholder="Wolt ID"
              value={woltId}
              onChange={(e) => setWoltId(e.target.value)}
            />
          </div>
          <div className="person-extra-section">
            <h3 className="person-extra-section-title">Podaci o vozilu</h3>
            <div className="form-group">
              <label>VOZILO:</label>
              <input
                type="text"
                placeholder="npr. Skuter"
                value={vozilo}
                onChange={(e) => setVozilo(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>VLASNIK:</label>
              <input
                type="text"
                placeholder="Vlasnik"
                value={vlasnik}
                onChange={(e) => setVlasnik(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>REGISTRACIJA:</label>
              <input
                type="text"
                placeholder="Registracija"
                value={registracija}
                onChange={(e) => setRegistracija(e.target.value)}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Firma:</label>
            <select
              value={firmId}
              onChange={(e) => setFirmId(e.target.value)}
              required
            >
              {firms.map((firm) => (
                <option key={firm.id} value={firm.id}>
                  {firm.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Fee %:</label>
            <input
              type="number"
              placeholder="Fee %"
              value={fee}
              onChange={(e) => setFee(parseFloat(e.target.value))}
              required
            />
          </div>
          <div className="form-group">
            <label>Acom (default):</label>
            <input
              type="number"
              value={acom}
              onChange={(e) => setAcom(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Sim (default):</label>
            <input
              type="number"
              value={sim}
              onChange={(e) => setSim(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Tax (default):</label>
            <input
              type="number"
              value={tax}
              onChange={(e) => setTax(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Rent (default):</label>
            <input
              type="number"
              value={rent}
              onChange={(e) => setRent(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Petrol (default):</label>
            <input
              type="number"
              value={petrol}
              onChange={(e) => setPetrol(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Utility (default):</label>
            <input
              type="number"
              value={utility}
              onChange={(e) => setUtility(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Advance (default):</label>
            <input
              type="number"
              value={advance}
              onChange={(e) => setAdvance(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Bonus (default):</label>
            <input
              type="number"
              value={bonus}
              onChange={(e) => setBonus(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Ostalo (default):</label>
            <input
              type="number"
              value={ostalo}
              onChange={(e) => setOstalo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Početni mjesec:</label>
            <select value={startMonth} onChange={(e) => setStartMonth(parseInt(e.target.value))}>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Početna godina:</label>
            <select value={startYear} onChange={(e) => setStartYear(parseInt(e.target.value))}>
              {Array.from({ length: new Date().getFullYear() + 1 - 2022 + 1 }, (_, i) => 2022 + i).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          <div className="button-group">
            <button type="submit" className="save-button">
              Spremi
            </button>
            <button type="button" onClick={closeModal} className="cancel-button">
              Odustani
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default PersonForm;
